
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinolympiatechpark() {



    const cardData =
    {
        keyword: ' Corporate Cab Service in Olympia Tech Park Chennai',
        heading: 'etravo : Corporate Cab Service in Olympia Tech Park Chennai',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Olympia Tech Park Chennai, designed for IT companies, MNCs, and professionals who require seamless transportation for daily employee commute, shift-based pickup and drop, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across Olympia Tech Park and surrounding business hubs.",

"top": "Top Corporate Cab Service Areas near Olympia Tech Park Chennai with eTravo",

"topPlaces": [
  {
    "title": "Olympia Tech Park (Guindy)",
    "description": "A major IT and business hub hosting multiple corporate offices, requiring structured employee transportation and executive cab services."
  },
  {
    "title": "Guindy Industrial Estate",
    "description": "A key industrial and commercial zone with offices and factories requiring daily workforce transportation and corporate mobility."
  },
  {
    "title": "SIDCO Industrial Estate (Guindy)",
    "description": "A cluster of industries and business units requiring reliable employee pickup and drop services."
  },
  {
    "title": "Kathipara Junction",
    "description": "A major connectivity hub linking key parts of Chennai, widely used for corporate travel and commuting."
  },
  {
    "title": "Alandur",
    "description": "A residential and commercial locality supporting professionals commuting to Olympia Tech Park."
  },
  {
    "title": "Velachery",
    "description": "A major residential hub for IT employees requiring daily office commute services."
  },
  {
    "title": "St. Thomas Mount",
    "description": "A key transit point near Guindy with access to metro and suburban rail, requiring integrated corporate travel solutions."
  },
  {
    "title": "Guindy to Airport Corridor",
    "description": "A crucial route connecting Olympia Tech Park to Chennai International Airport for executive and corporate travel."
  },
  {
    "title": "Taramani & OMR IT Corridor",
    "description": "A major IT belt connected to Guindy with high demand for inter-office travel and employee transportation."
  },
  {
    "title": "Mount Road (Anna Salai)",
    "description": "A central business corridor with corporate offices and commercial establishments requiring executive cab services."
  }
],


"services": [
{
"name": "Corporate Cab Olympia Tech Park Chennai",
"description": "eTravo offers reliable corporate cab services in Olympia Tech Park Chennai designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Olympia Tech Park Chennai",
"description": "Our taxi services in Olympia Tech Park Chennai provide quick and dependable transportation for professionals. eTravo ensures clean vehicles, timely service, and hassle-free travel within the tech park and surrounding areas."
},
{
"name": "Company Cab Olympia",
"description": "eTravo provides company cab services in Olympia tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Olympia Tech Park",
"description": "Simplify employee commuting with eTravo’s office transport services in Olympia Tech Park. We offer structured and efficient transportation solutions for daily travel across corporate offices."
},
{
"name": "Employee Cab Olympia",
"description": "Our employee cab services in Olympia are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel Olympia Chennai",
"description": "eTravo offers corporate travel services in Olympia Chennai for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab Olympia",
"description": "eTravo’s business cab services in Olympia are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport Olympia Tech Park",
"description": "eTravo provides dependable staff transport services in Olympia Tech Park for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient coordination."
},
{
"name": "Corporate Taxi Olympia",
"description": "Our corporate taxi services in Olympia offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi Olympia Chennai",
"description": "eTravo’s company taxi services in Olympia Chennai provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop Olympia",
"description": "eTravo offers corporate pickup and drop services in Olympia for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking Olympia",
"description": "Book office cabs in Olympia easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab Olympia",
"description": "Our business travel cab services in Olympia are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute Olympia Chennai",
"description": "eTravo’s corporate commute services in Olympia Chennai provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Olympia",
"description": "eTravo offers professional cab services in Olympia with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab Olympia Tech Park Chennai", "Taxi Olympia Tech Park Chennai"],
["Company Cab Olympia", "Office Transport Olympia Tech Park"],
["Employee Cab Olympia", "Corporate Travel Olympia Chennai"],
["Business Cab Olympia", "Staff Transport Olympia Tech Park"],
["Corporate Taxi Olympia", "Company Taxi Olympia Chennai"],
["Corporate Pickup Drop Olympia", "Office Cab Booking Olympia"],
["Business Travel Cab Olympia", "Corporate Commute Olympia Chennai"],
["Professional Cab Olympia", ""]
],



"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Service in Olympia Tech Park Chennai",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in Olympia Tech Park Chennai, ensuring smooth and efficient transportation for employees, executives, and corporate teams."
    },
    {
      "WhyChooseheading": "Ideal for Olympia Tech Park Business Hub",
      "WhyChoosedescription": "Olympia Tech Park in Guindy is one of Chennai’s largest IT office locations with major corporate occupants and over 1.4 million sq. ft. of workspace, making structured employee transport essential. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Services",
      "WhyChoosedescription": "Corporate cab services provide organized daily pickup and drop with optimized routes, ensuring employees reach offices on time and improving productivity."
    },
    {
      "WhyChooseheading": "Flexible Shift-Based Transportation Solutions",
      "WhyChoosedescription": "With companies operating in multiple shifts, cab services support safe and timely travel for day, night, and rotational shift employees."
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Travel Needs",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and larger vehicles suitable for employee commute, executive travel, and group transportation requirements."
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet and Real-Time Tracking",
      "WhyChoosedescription": "Corporate cab services use GPS tracking, route optimization, and centralized monitoring systems to ensure safety, efficiency, and transparency in employee transportation."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Local Expertise",
      "WhyChoosedescription": "Experienced drivers familiar with Guindy, Inner Ring Road, and surrounding areas ensure safe, punctual, and efficient travel for employees."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Operations",
      "WhyChoosedescription": "Round-the-clock support ensures seamless coordination, quick issue resolution, and uninterrupted corporate mobility for businesses in Olympia Tech Park."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Olympia Tech Park Chennai?',
            answer: 'Corporate cab service in Olympia Tech Park Chennai provides organized transportation for employees, executives, and clients including daily office commute and business travel.',
        },
        {
            question: 'Where is Olympia Tech Park located in Chennai?',
            answer: 'Olympia Tech Park is located in Guindy on Inner Ring Road, one of Chennai’s major business districts. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules for employees.',
        },
        {
            question: 'Can transportation be arranged for multiple shifts?',
            answer: 'Yes, corporate cab services support day, night, and rotational shifts with flexible scheduling.',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, buses, and luxury cars depending on workforce size and requirements.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols ensuring secure travel.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on workforce requirements.',
        },
        {
            question: 'Are corporate cab services available 24/7 in Olympia Tech Park?',
            answer: 'Yes, most providers operate round the clock to support corporate travel and shift-based operations.',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are available, and Olympia Tech Park is located about 5 km from Chennai Airport. :contentReference[oaicite:2]{index=2}',
        },
        {
            question: 'How can I book corporate cab service in Olympia Tech Park Chennai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Iyer',
        designation: 'Operations Manager, IT Company, Olympia Tech Park',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our employee transport in Olympia Tech Park. Their punctual service and route management make daily commuting smooth and efficient.”',
    },
    {
        name: 'Ms. Divya Narayanan',
        designation: 'HR Manager, Corporate Firm, Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for corporate cab services in Olympia Tech Park. Their flexibility and reliable service ensure stress-free commuting for our employees.”',
    },
];



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Olympia Tech Park Chennai",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-olympia-tech-park-chennai.jpg",
  "description": "Reliable corporate cab services in Olympia Tech Park, Chennai by eTravo. Ideal for IT employee transport, office pickup and drop, business travel, corporate commute, and professional cab services with safe and timely rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-in-olympia-tech-park-chennai"
  }
};


    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Olympia Tech Park Chennai | IT Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab service in Olympia Tech Park, Chennai with eTravo for IT employee transport, office commute, business travel, and corporate pickup and drop services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/162.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinolympiatechpark;